var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',_vm._l((_vm.row),function(item,index){return _c('modeling-options-row',{key:index,attrs:{"setting":item},on:{"input":function($event){return _vm.$emit('input', $event)}}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }